import {AuthenticationMethodType} from "@vesta/vos-types/modules/platformLevel/authentication/domain/AuthenticationMethodType";
import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

export type AuthenticatedUserAuthMethod = {
    createdAt: Iso8601DateTime;
    id: Uuid;
} & (
    | {
          type: AuthenticationMethodType.otpViaEmail;
          email: string;
      }
    | {
          type: AuthenticationMethodType.otpViaSms;
          phoneNumber: string;
      }
    | {
          type: AuthenticationMethodType.passwordViaEmail;
          email: string;
      }
    | {
          type: AuthenticationMethodType.ssoViaGoogle;
          email: string;
      }
    | {
          type: AuthenticationMethodType.ssoViaMicrosoft;
          email: string | null;
      }
    | {
          type: AuthenticationMethodType.impersonate;
      }
);

export const authenticatedUserAuthMethodZodValidator = zod.discriminatedUnion("type", [
    zod.object({
        createdAt: iso8601DateTimeZodValidator,
        id: uuidZodValidator,
        type: zod.literal(AuthenticationMethodType.otpViaEmail),
        email: zod.string(),
    }),
    zod.object({
        createdAt: iso8601DateTimeZodValidator,
        id: uuidZodValidator,
        type: zod.literal(AuthenticationMethodType.otpViaSms),
        phoneNumber: zod.string(),
    }),
    zod.object({
        createdAt: iso8601DateTimeZodValidator,
        id: uuidZodValidator,
        type: zod.literal(AuthenticationMethodType.passwordViaEmail),
        email: zod.string(),
    }),
    zod.object({
        createdAt: iso8601DateTimeZodValidator,
        id: uuidZodValidator,
        type: zod.literal(AuthenticationMethodType.ssoViaGoogle),
        email: zod.string(),
    }),
    zod.object({
        createdAt: iso8601DateTimeZodValidator,
        id: uuidZodValidator,
        type: zod.literal(AuthenticationMethodType.ssoViaMicrosoft),
        email: zod.string().nullable(),
    }),
    zod.object({
        createdAt: iso8601DateTimeZodValidator,
        id: uuidZodValidator,
        type: zod.literal(AuthenticationMethodType.impersonate),
    }),
]);
